import styled, { keyframes } from "styled-components";
import { StaggerReveal } from "../../ui/Motion";

export const Header = styled(StaggerReveal)`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing["3xl"]};
`;

const ITEM_GAP = 24;

const marqueeScroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

export const MarqueeWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  /* Vertical breathing room so hover lift + shadow don't get clipped */
  padding: 16px 0 56px;
  margin: -16px 0 -56px;

  /* Edge fade: softens entry/exit on both sides */
  mask-image: linear-gradient(
    to right,
    transparent 0,
    #000 80px,
    #000 calc(100% - 80px),
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0,
    #000 80px,
    #000 calc(100% - 80px),
    transparent 100%
  );

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    mask-image: linear-gradient(
      to right,
      transparent 0,
      #000 40px,
      #000 calc(100% - 40px),
      transparent 100%
    );
    -webkit-mask-image: linear-gradient(
      to right,
      transparent 0,
      #000 40px,
      #000 calc(100% - 40px),
      transparent 100%
    );
  }
`;

export const MarqueeTrack = styled.div`
  display: flex;
  width: max-content;
  animation: ${marqueeScroll} 40s linear infinite;
  will-change: transform;

  &:hover {
    animation-play-state: paused;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const BrandLogo = styled.a`
  flex: 0 0 auto;
  width: 220px;
  margin-right: ${ITEM_GAP}px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacing.xl} ${theme.spacing.lg}`};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid rgba(15, 23, 42, 0.04);
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 2px 6px rgba(15, 23, 42, 0.05);
  transition:
    transform ${({ theme }) => theme.transitions.normal},
    box-shadow ${({ theme }) => theme.transitions.normal};
  min-height: 110px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primaryDark};

  img {
    display: block;
    width: auto;
    height: auto;
    max-width: 70%;
    max-height: 48px;
    object-fit: contain;
    /* PNG logos (Itama, Focus) are baked in primaryDark (#3b546d) to match the
       inline-SVG logos, so no colour filter is needed here. */
    transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }

  svg {
    width: 70%;
    color: ${({ theme }) => theme.colors.primaryDark};
    transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }

  &[data-brand="princess"] svg {
    width: 45%;
  }

  &[data-brand="ribco"] svg {
    width: 80%;
  }
  &[data-brand="nex"] svg {
    width: 60%;
  }

  &:hover {
    box-shadow:
      0 2px 4px rgba(15, 23, 42, 0.06),
      0 6px 16px rgba(15, 23, 42, 0.08);
    transform: translateY(-1px);
  }

  &:hover svg,
  &:hover img {
    transform: scale(1.04);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 180px;
    padding: ${({ theme }) => `${theme.spacing.lg} ${theme.spacing.md}`};
    min-height: 90px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 150px;
    margin-right: 16px;
  }
`;

export const EmptyBrands = styled.div`
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${({ theme }) => theme.colors.midGray};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const BrandName = styled.span`
  font-family: ${({ theme }) => theme.fonts.caps};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacings.wider};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.midGray};
`;
